import { render, staticRenderFns } from "./OrgMonitorRatings.vue?vue&type=template&id=b9c7080c&scoped=true"
import script from "./OrgMonitorRatings.vue?vue&type=script&lang=js"
export * from "./OrgMonitorRatings.vue?vue&type=script&lang=js"
import style0 from "./OrgMonitorRatings.vue?vue&type=style&index=0&id=b9c7080c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c7080c",
  null
  
)

export default component.exports